const useGetTokenCT = async (): Promise<string | null> => {
  try {
    const response = await fetch("/api/get-commercetools-token", {
      method: "POST",
    });

    const data = await response.json();
    return data.token || null;
  } catch (error) {
    console.error("Error fetching token from API:", error);
    return null;
  }
};

export default useGetTokenCT;
